import { useEffect, useMemo, useRef } from 'react';

import { useBreakpoints } from '../../../../hooks/useBreakpoints';

export const useMobileAutofocus = (showDropdown: boolean) => {
    const isSmallScreen = useBreakpoints({ breakpoint: 'sm' });

    const mobileInputRef = useRef<HTMLInputElement | null>(null);
    const mobileInputContainerRef = useRef<HTMLDivElement | null>(null);

    const isIOS = useMemo(() => {
        if (typeof navigator === 'undefined') return false;
        const ua = navigator.userAgent || '';

        const iOS = /\b(iPad|iPhone|iPod)\b/i.test(ua);
        const iPadOS = ua.includes('Macintosh') && navigator.maxTouchPoints > 1;

        return iOS || iPadOS;
    }, []);

    useEffect(() => {
        if (!showDropdown || !isSmallScreen) return;

        const el = mobileInputRef.current ?? mobileInputContainerRef.current?.querySelector('input') ?? null;

        if (!el) return;

        const t = setTimeout(
            () => {
                try {
                    el.click();
                    el.focus({ preventScroll: true });
                    const pos = el.value?.length ?? 0;
                    el.setSelectionRange?.(pos, pos);
                } catch {}
            },
            isIOS ? 150 : 0,
        );

        return () => clearTimeout(t);
    }, [showDropdown, isSmallScreen, isIOS]);

    return { isSmallScreen, mobileInputRef, mobileInputContainerRef } as const;
};
